import {
  SharedAccessesForTaskDocument,
  UnshareTaskDocument,
  UnshareTaskMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUnshareTask = () => {
  const [unshareTask, { loading }] = useMutation(UnshareTaskDocument, {
    extractorFn: (data) => data.tasksMutations.unshareTasksShareTask,
  })

  return {
    unshareTask: (variables: UnshareTaskMutationVariables) => {
      return unshareTask({
        variables,
        refetchQueries: [
          {
            query: SharedAccessesForTaskDocument,
            variables: {
              taskId: variables.taskId,
            },
          },
        ],
      })
    },
    loading,
  }
}
